/**
 * Single visible background job notice for Manage Returns (show / clear / close).
 */
import { makeAutoObservable } from "mobx";
import { ActionButtonProps } from "../../../../components/toast-messages-modal/toast-messages-store";

export enum BACKGROUND_JOB_NOTICE_STATE {
    IN_PROGRESS = "in-progress",
    COMPLETE = "complete",
    PARTIAL = "partial",
    STOPPED = "stopped",
}

export interface IBackgroundJobNotice {
    state: BACKGROUND_JOB_NOTICE_STATE;
    title: string;
    description?: React.ReactNode;
    actionButton?: ActionButtonProps;
    onClose?: () => void;
}

class BackgroundJobNoticesStore {
    private _notice: BackgroundJobNoticeStore | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    /** Replaces any existing notice; only one notice may be visible at a time. */
    public show(model: IBackgroundJobNotice): BackgroundJobNoticeStore {
        this.clear();
        this._notice = new BackgroundJobNoticeStore(model, this.clear);
        return this._notice;
    }

    public clear(): void {
        this._notice = null;
    }

    public get notice(): BackgroundJobNoticeStore | null {
        return this._notice;
    }
}

export class BackgroundJobNoticeStore {
    constructor(
        private _model: IBackgroundJobNotice,
        private _clear: () => void,
    ) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private _remove(): void {
        this._clear();
    }

    public close(): void {
        this._model.onClose?.();
        this._remove();
    }

    public get state(): BACKGROUND_JOB_NOTICE_STATE {
        return this._model.state;
    }

    public get title(): string {
        return this._model.title;
    }

    public get description(): React.ReactNode {
        return this._model.description;
    }

    public get actionButton(): ActionButtonProps | undefined {
        return this._model.actionButton;
    }

    public get onClose(): (() => void) | undefined {
        return this._model.onClose;
    }
}

const backgroundJobNoticesStore = new BackgroundJobNoticesStore();
export default backgroundJobNoticesStore;
